module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content newsweekly"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 center-box"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive no-padding"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleDownload(item)
        }
      }
    }, [_vm._v("Download")])])])
  })], 2)])])])])])]), _vm._v(" "), (_vm.isAdminInApp) ? _c('div', {
    staticClass: "add-app-bgcolor dropup"
  }, [_c('button', {
    staticClass: "add-app-btn",
    on: {
      "click": _vm.handleCreate
    }
  }, [_vm._m(2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("News Weekly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "td-right"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62bc1d91", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62bc1d91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DinNewsWeekly.vue
// module id = 476
// module chunks = 1